import { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import useAuthStore from '../stores/useAuthStore'
import { hasValidToken } from '../utils/storage'

/**
 * ProtectedRoute Component
 * Wrapper for routes that require authentication
 * Redirects to login if user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation()
  const { isAuthenticated, user, token } = useAuthStore()
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    console.log('🔒 [ProtectedRoute] Checking authentication...')
    console.log('🔒 [ProtectedRoute] isAuthenticated:', isAuthenticated)
    console.log('🔒 [ProtectedRoute] hasValidToken:', hasValidToken())
    console.log('🔒 [ProtectedRoute] user:', user)
    console.log('🔒 [ProtectedRoute] token exists:', !!token)

    // Just verify we have auth data - don't make API calls
    setChecking(false)
  }, [isAuthenticated, user, token])

  // Show loading spinner during initial check
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="inline-block w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full animate-spin mb-4" />
          <p className="text-gray-600 dark:text-gray-400">جاري التحقق...</p>
        </div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  // Check both store state AND localStorage token
  if (!isAuthenticated || !hasValidToken()) {
    console.log('❌ [ProtectedRoute] Not authenticated, redirecting to login')
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  console.log('✅ [ProtectedRoute] Authenticated, rendering protected content')
  // Render protected content
  return children
}

export default ProtectedRoute
